import { uniqBy } from 'lodash';

import { ErrorLog, postErrorLog } from '@/utils/api';

const removeDeduplicateArray = (array: ErrorLog[]): ErrorLog[] => {
  return uniqBy(
    array,
    (item: { groupName: any; detail: { error: any } }) => `${item.groupName}-${item.detail.error}-${item.detail.etc}`,
  );
};

class ErrorReportStore {
  logList: ErrorLog[] = [];

  POC = { APP_POPULAR: 'pc-popular' } as const;

  log = (log: ErrorLog): void => {
    this.logList = removeDeduplicateArray(this.logList.concat(log));
  };

  sendErrorLog = async (): Promise<void> => {
    await postErrorLog(this.logList);
    this.logList = [];
  };

  flush = (): void => {
    setInterval(() => {
      this.sendErrorLog();
    }, 5000);
  };

  getPoc = () => {
    return this.POC;
  };

  getUserAgent = () => {
    try {
      return navigator.userAgent || navigator.vendor || window.opera || 'no-userAgent';
    } catch (e) {
      return 'ErrorReportStore:getUserAgent';
    }
  };

  getErrorMessage = (e: { name: any; message: string }): string => {
    try {
      return `${e.name}: ${this.getNLines(e.message, 1)}`;
    } catch (e) {
      return 'ErrorReportStore:getErrorMessage';
    }
  };

  getNLines = (message: string, n: number): string => {
    let count = 0;
    for (let i = 0; i < message.length; i++) {
      if (message[i] === '\n') {
        count++;
        if (count === n) {
          return message.substring(0, i);
        }
      }
    }
    return message;
  };

  getErrorMethodName = (e: { methodName: string }): string => {
    return e.methodName;
  };

  updateErrorMethodName = (e: { methodName: string }, methodName: string) => {
    if (!e) return;
    e.methodName = e.methodName ? `${methodName} > ${e.methodName}` : methodName;
  };
}

export default new ErrorReportStore();
